<template>
	<div class="form-card">
		<slot />
	</div>
</template>
